import { createSlice } from "@reduxjs/toolkit";
import { getNotificationListAll } from "../Actions/NotificationActions";

const initialState = {
    loading: false,
    notificationListAll: [],
}

const NotificationAllSlice = createSlice({
    name: "notifications",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getNotificationListAll.fulfilled, (state, { payload }) => {
            if (payload?.statusCode === 200) {
                state.success = true;
                state.notificationListAll = payload.data;
            } else {
                state.success = false;
                state.error = payload?.message
            }
        })
    },
});

export default NotificationAllSlice.reducer;